<template>
  <!-- 站点公告详情页面 -->
  <div class="page-container">
    <!-- 公告信息卡片 -->
    <div class="page-card">
      <!-- 公告头部 -->
      <div class="page-card__header">
        <el-row>
          <el-col :span="2">
            <span style="font-size: 18px; font-weight: bold; line-height: 40px">公告信息</span>
          </el-col>
          <el-col :span="22">
            <div style="text-align: right">
              <el-button
                type="primary"
                size="small"
                @click="updateInfo"
              >修改
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 公告内容展示 -->
      <div v-if="updateShow" class="page-card__body">
        <div
          style="
            font-size: 18px;
            line-height: 40px;
            padding: 10px 0;
            font-weight: bold;
          "
        >
          {{ dataInfo.title }}
        </div>
        <div style="width: 800px; margin: 0 auto">
          <div v-html="dataInfo.info" id="info"></div>
        </div>

        <div style="font-size: 12px; margin: 40px 0; text-align: right">
          <span style="margin-right: 10px">阅读数：{{ dataInfo.view }}</span>
          <span style="margin-right: 10px">点赞数：{{ dataInfo.praise }}</span>
        </div>
      </div>

      <!-- 公告编辑表单 -->
      <div v-else class="page-card__body">
        <el-form label-width="100px" :model="form" ref="form" :rules="rules">
          <el-form-item label="新闻类型" prop="type" style="text-align: left">
            <el-radio-group v-model="form.type" prop="type">
              <el-radio :label="1">小程序</el-radio>
              <el-radio :label="2">展商</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="公告标题" prop="title">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item prop="img" label="封面图" style="text-align: left">
            <el-image
              v-if="form.img !== ''"
              :src="imgUrl + form.img"
              style="width: 120px; height: 90px"
            ></el-image>
            <el-upload
              class="avatar-uploader"
              :action="imagesrc"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :headers="headers"
              :before-upload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary" round
              >点击上传封面图
              </el-button>
              <div slot="tip" class="el-upload__tip">
                最佳展示尺寸：1:1，建议500 x 500像素以上
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="公告内容" prop="info">
            <vue-html5-editor
              :content="form.info"
              :height="300"
              v-model="form.info"
              :show-module-name="showModuleName"
              @change="updateData"
              ref="editor"
            ></vue-html5-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" round size="small" @click="onBaseSubmit('form')">
              提交修改
            </el-button>
            <el-button round size="small" @click="updateInfo">取消修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../../utils/api";
  import {VueEditor} from "vue2-editor";

  export default {
    name: "stationInfoDetail",
    data() {
      return {
        updateShow: true,
        showModuleName: true,
        form: {
          title: "",
          info: "",
          type: "",
          img: "",
        },
        headers: {Authorization: "JWT " + localStorage.getItem("adminToken")},
        imagesrc: this.baseUrl + "/user/uploadfile/news_banner/",
        imgUrl:
          "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news_banner/",
        newimgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/",
        dataInfo: [],
        id: "",
        rules: {
          title: [{required: true, message: "请输入活动名称", trigger: "blur"}],
          info: [{required: true, message: "请输入活动内容", trigger: "blur"}],
          type: [{required: true, message: "请输入活动类型", trigger: "blur"}],
          img: [{required: true, message: "请输入活动类型", trigger: "blur"}],
        },
      };
    },
    mounted() {
      // 初始化加载公告详情
      this.id = this.$route.query.id;
      this.getData();
    },
    methods: {
      // 获取公告详情数据
      getData() {
        let id = this.id;
        let url = this.baseUrl + "/admin/news/" + id + "/";
        api.fetchData(url).then((res) => {
          this.dataInfo = res;
          this.form = res;
        });
      },

      // 提交修改公告信息
      onBaseSubmit(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let id = this.id;
            let url = this.baseUrl + "/admin/news/" + id + "/";
            api
              .patchData(url, {
                title: this.form.title,
                type: this.form.type,
                info: this.form.info,
                img: this.form.img,
              })
              .then((res) => {
                this.$message({
                  message: "修改公告成功",
                  type: "success",
                });
                this.getData();
                this.updateInfo();
              });
          }
        });
      },

      // vue-html5-editor富文本函数
      updateData: function (data) {
        this.form.info = data;
      },

      // 富文本编辑器上传图片回调函数
      handleImageAdded(file, Editor, cursorLocation, resetUploader) {
        let url = this.baseUrl + "/admin/uploadfile/news/";
        const formData = new FormData();
        formData.append("file", file);
        api.postData(url, formData).then((res) => {
          Editor.insertEmbed(
            cursorLocation,
            "image",
            this.newimgUrl + res.filename
          );
          resetUploader();
        });
      },

      // 封面图上传成功回调
      handleAvatarSuccess(res, file) {
        let imageUrl = URL.createObjectURL(file.raw);
        this.form.img = res.filename;
      },

      // 图片上传前校验
      beforeAvatarUpload(file) {
      },

      // 切换公告展示/编辑状态
      updateInfo() {
        this.updateShow = this.updateShow === true ? false : true;
      },
    },
    components: {
      VueEditor,
    },
  };
</script>


<style>
  img {
    width: 100% !important;
    height: 100% !important;
  }

  ::v-deep .vue-html5-editor > .content {
    max-height: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/stationInfoDetail.vue